"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var TransparencyButton = /** @class */ (function (_super) {
    __extends(TransparencyButton, _super);
    function TransparencyButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransparencyButton.prototype.componentDidMount = function () {
        if (this.element) {
            var clickEventListener = function (event) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            };
            this.element.addEventListener('click', clickEventListener);
        }
        if (this.element) {
            var mousedownEventListener = function (event) {
                event.preventDefault();
                return false;
            };
            this.element.addEventListener('mousedown', mousedownEventListener);
        }
    };
    TransparencyButton.prototype.click = function () {
        if (this.element) {
            var button = this.element.firstElementChild;
            if (button && button instanceof HTMLElement) {
                button.click();
            }
        }
    };
    TransparencyButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, adObj = _a.adObj, placement = _a.placement, className = _a.className, style = _a.style;
        var defaultStyle = {};
        if (placement) {
            var cornerStyle = {
                position: 'absolute',
                height: '26px',
                width: '26px',
                backgroundColor: 'rgba(255, 255, 255, 0.45)',
                zIndex: 2,
            };
            var placementStyle = {};
            if (placement === 'right') {
                placementStyle = {
                    top: '0px',
                    right: '0px',
                    borderRadius: '0 0 0 8px',
                };
            }
            if (placement === 'left') {
                placementStyle = {
                    top: '0px',
                    left: '0px',
                    borderRadius: '0 0 8px 0',
                };
            }
            defaultStyle = __assign(__assign({}, cornerStyle), placementStyle);
        }
        return (React.createElement("div", { id: adObj.targetId + "-button", className: className, style: __assign(__assign({}, defaultStyle), style), ref: function (element) { return (_this.element = element); } }));
    };
    return TransparencyButton;
}(React.Component));
exports.default = TransparencyButton;
